import { debounce } from "@utils";
import { create } from "zustand";

interface SearchStoreState {
  searchQuery: string | null;
  search: (query: string) => void;
  reset: () => void;
}

export const useSearchStore = create<SearchStoreState>((set, get) => ({
  searchQuery: null,
  search: (searchQuery) => {
    debounce(() => set({ searchQuery }), "search", 200);
  },
  reset: () => set({ searchQuery: "" }),
}));

export function useSearchQuery() {
  return useSearchStore((store) => store.searchQuery);
}
